export default __webpack_public_path__ + "static/media/slide-3.eabebf19.webp";